import { redirectToken as redirectTokenApi } from './api';

let setPatient = (patient) => dispatch => {
  dispatch({ type: 'SET_PATIENT', payload: patient })
}

let redirectToken = (data) => dispatch => {
  return redirectTokenApi(data)
}

export {
  setPatient,
  redirectToken
}
